import { createFileRoute } from '@tanstack/react-router'
import { GroupSettingsPage } from '@/features/settings/components/GroupSettingsPage'

export const Route = createFileRoute('/_authed/settings/group')({
  component: GroupSettingsPage,
})
